import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Navigate, useLocation } from 'react-router-dom';
import { useCabinetMenuAccess } from '../hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
  path: string;
}

const ProtectedRoute = ({ children, path }: ProtectedRouteProps) => {
  const { canAccessMenu, isAuthReady } = useCabinetMenuAccess();
  const location = useLocation();

  if (!isAuthReady) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 240,
          width: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!canAccessMenu(path)) {
    return (
      <Navigate
        to="/cabinet/facebook/ads-history"
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
